import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import SaleFooter from '../SaleFooter/SaleFooter';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../../provider/providerManager';
import { getRecaptchaToken } from '../../../../utilities/recaptcha/recaptcha';
import { setPhoneListData } from '../../../../Components/Block/EsimGeneralBlock/esimBlockSlice';
import {
  goToPage,
  reportAnalytics,
  reportFbqAnalytics,
  setIsSubmit,
  setIsValid,
  setPhoneForDelivery,
  setError,
  setTransactionId,
} from '../saleBlockSlice';
import AlmostDone from '../AlmostDone/AlmostDone';

const SummaryPage = (props) => {
  let saleType = props.saleType;
  let flowType = props.flowType;

  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    switch (saleType) {
      case 'tv':
        props.reportAnalytics({
          eventCategory: 'tv_newsale_process',
          eventAction: flowType == 'existsCustomer' ? 'visibility_13' : 'visibility_23',
          eventLabel: eventLabel,
        });
        break;
      case 'app':
        props.reportAnalytics({ eventCategory: 'app_newsale_process', eventAction: 'visibility_31', eventLabel: eventLabel });
        break;
      case 'cellular':
        props.reportAnalytics({
          eventCategory: 'cellular_newsale_process',
          eventAction: flowType == 'existsCustomer' ? 'visibility_14' : 'visibility_26',
          eventLabel: flowType == 'existsCustomer' ? 'screen_9' : 'screen_16',
        });
        break;
      case 'internet':
        props.reportAnalytics({
          eventCategory: 'fiber_newsale_process',
          eventAction: flowType == 'existsCustomer' ? 'visibility_27' : 'visibility_20',
          eventLabel: eventLabel,
        });
        break;
    }
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = 'אישור והזמנה';
  let currentPageFunction = handleSummaryPageContinue;
  let totalPrice = null;
  let priceText = 'לחודש';
  let formid = 'sale';
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'>בואו נסכם<br />לפני שמתקדמים</h1>
    </div>
  );

  const isAddressConnectedToIBC = props.selectedAddress?.infrastructure?.tashtitType == 'IBC';
  const isDisplayTechnicianArrivalTimeIbc = saleType == 'internet' && isAddressConnectedToIBC && props.isCustomerConnectedToIbc == false;

  let saleInfo = {
    personalInfo: props.personalInfo,
    offerInfo: props.offerInfo,
    premiumPackages: props.premiumPackages,
    totalPrice: props.totalPrice,
    totalPriceOneTime: props.totalPriceOneTime,
    supplyType: props.supplyType,
    deliveryCost: props.deliveryCost,
    saleType: props.saleType,
    flowType: props.flowType,
    selectedAddress: props.selectedAddress,
    phoneForDelivery: props.phoneForDelivery,
    otpPhone: props.otpPhone,
    productsInfo: props.productsInfo,
    setupDeliveries: props.setupDeliveries,
    technicianArrivalTime: props.technicianArrivalTime,
    technicianArrivalTimeIbc: props.technicianArrivalTimeIbc,
    isDisplayTechnicianArrivalTimeIbc: isDisplayTechnicianArrivalTimeIbc,
    isMeshUpgrade: props.isMeshUpgrade,
    paymentToken: props.accountInfo.paymentToken,
  };

  let currentPageView = (
    <AlmostDone
      saleInfo={saleInfo}
      onValid={handleSummaryPageValidate}
      onSubmit={props.isSubmit}
      termsLink={props.productsInfo.baseProduct.productTermsLink}
    />
  );

  function handleSummaryPageContinue() {
    props.setIsSubmit({ isSubmit: true });
  }

  function handleSummaryPageValidate(valid) {
    props.setIsSubmit({ isSubmit: false });
    if (valid) {
      handleSummaryPageContinueAfterValid();
    }
    props.setIsSubmit({ isSubmit: false });
  }

  async function handleSummaryPageContinueAfterValid() {
    props.setPhoneForDelivery({ phoneForDelivery: props._phoneForDelivery });

    var list = props.productsInfo.selectedProducts.map((data, index) => {
      return [data.name];
    });
    list.push(`סה"כ ${props.totalPrice} ש"ח`);
    let eventLabel = list.join(',');

    switch (saleType) {
      case 'tv':
        props.reportAnalytics({
          eventCategory: 'tv_newsale_process',
          eventAction: flowType == 'existsCustomer' ? 'click_18' : 'click_33',
          eventLabel: eventLabel,
        });
        props.reportFbqAnalytics({ event: 'InitiateCheckout', data: { Product_type: 'TV', value: props.totalPrice, currency: 'ILS' } });
        break;
      case 'app':
        props.reportAnalytics({ eventCategory: 'app_newsale_process', eventAction: 'click_43', eventLabel: eventLabel });
        break;
      case 'cellular':
        props.reportAnalytics({
          eventCategory: 'cellular_newsale_process',
          eventAction: flowType == 'existsCustomer' ? 'click_29' : 'click_49',
          eventLabel: eventLabel,
        });
        props.reportFbqAnalytics({ event: 'InitiateCheckout', data: { Product_type: 'Cellular', value: props.totalPrice, currency: 'ILS' } });
        break;
      case 'internet':
        props.reportAnalytics({
          eventCategory: 'fiber_newsale_process',
          eventAction: flowType == 'existsCustomer' ? 'click_37' : 'click_26',
          eventLabel: eventLabel,
        });
        props.reportFbqAnalytics({ event: 'InitiateCheckout', data: { Product_type: 'Fiber', value: props.totalPrice, currency: 'ILS' } });
        break;
    }

    switch (saleType) {
      case 'tv':
        if (flowType == 'existsCustomer') {
          if (!props.isCustomerExposureSuccess) {
            props.setError({ isDisplay: true, id: 1, isOpenWorkOrder: true });
            return;
          }

          const isMakeSaleSuccess = await makeSale(props.personalInfo.ban);
          if (!isMakeSaleSuccess) {
            return;
          }
          props.goToPage({ page: 'successPage', percent: 100 });
        } else {
          props.goToPage({ page: 'paymentPage', percent: 90 });
        }
        break;
      case 'app':
        props.goToPage({ page: 'paymentPage', percent: 84 });
        break;
      case 'cellular':
        if (flowType == 'existsCustomer') {
          if (!props.isCustomerExposureSuccess) {
            props.setError({ isDisplay: true, id: 1, isOpenWorkOrder: true });
            return;
          }

          const isMakeSaleSuccess = await makeSale(props.personalInfo.ban);
          if (!isMakeSaleSuccess) {
            return;
          }
          props.goToPage({ page: 'successPage', percent: 100 });
        } else {
          props.goToPage({ page: 'paymentPage', percent: 90 });
        }
        break;
      case 'internet':
        if (flowType == 'existsCustomer') {
          if (!props.isCustomerExposureSuccess) {
            props.setError({ isDisplay: true, id: 1, isOpenWorkOrder: true });
            return;
          }

          const isMakeSaleSuccess = await makeSale(props.personalInfo.ban);
          if (!isMakeSaleSuccess) {
            return;
          }

          props.goToPage({ page: 'successPage', percent: 100 });
        } else {
          props.goToPage({ page: 'paymentPage', percent: 90 });
        }
        break;
    }
  }

  //1716
  async function makeSale(ban) {
    const captchaToken = await getRecaptchaToken('makeSale');
    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }

    props.showAppLoader();
    try {
      const personalInfo = {
        firstName: props.personalInfo.firstName,
        lastName: props.personalInfo.lastName,
        id: props.personalInfo.id,
        email: props.personalInfo.email,
        isReceivingAd: props.personalInfo.isReceivingAd,
        isReceivingBill: props.personalInfo.isReceivingBill,
        ban: ban,
      };

      const vasList = [];
      props.premiumPackages.forEach(function (item) {
        if (item.isSelected) {
          item.vasList.forEach(function (vas) {
            if (vas.isSelected) {
              vasList.push(vas.id);
            }
          });
        }
      });

      const saleWizard = {
        token: captchaToken,
        blockId: props.blockId,
        saleType: props.saleType,
        flowType: props.flowType,
        offerId: props.offerInfo.offerId,
        products: props.productsInfo.selectedProducts,
        vasList: vasList,
        selectedAddress: props.selectedAddress,
        personalInfo: personalInfo,
        accountInfo: props.accountInfo,
        otpPhone: props.otpPhone,
        otpCode: props.otpCode,
        otpTicketId: props.otpTicketId,
        payment: props.payment,
        phoneForDelivery: props.phoneForDelivery,
        supplyType: props.supplyType,
        setupDeliveries: props.setupDeliveries,
        technicianArrivalTimeIbc: props.technicianArrivalTimeIbc,
        technicianArrivalTime: props.technicianArrivalTime,
        deliveryCost: props.deliveryCost,
        totalPrice: props.totalPrice,
        isMeshUpgrade: props.isMeshUpgrade,
        nvIipSeq: props.nvIipSeq,
        isProductUpgraded: props.isProductUpgraded,
        isSkipToNewCustomer: props.isSkipToNewCustomer,
        isFamilyPackage: props.isFamilyPackage
      };

      console.info('makeSale', JSON.stringify(saleWizard));
      const result = await ProviderManager.getProviderData('makeSale', saleWizard);
      console.info('makeSale', result);
      const isSuccess = result.Header.ReturnCode == 0 && result.Body.isSuccess;
      const isEsimSuccess = result?.Body?.isSuccess && result?.Body?.extra?.success == true;
      if (!isSuccess) {
        if (result.Body.codeError == '94') {
          props.setError({ isDisplay: true, id: 13, isOpenWorkOrder: true });
        } else {
          makeSaleShowError(result.Header.ReturnCode);
        }
      }

      if (isEsimSuccess) {
        props.setPhoneListData(result?.Body?.extra?.data);
      }

      props.setTransactionId(result.Body.resultMessage);
      return isSuccess;
    } catch (error) {
      console.info('makeSale', error);
      makeSaleShowError(error.errorCode);

      return false;
    } finally {
      props.hideAppLoader();
    }
  }

  function makeSaleShowError(errorCode) {
    switch (errorCode) {
      case 57:
      case 58:
      case 59:
      case 60:
        props.setError({ isDisplay: true, id: errorCode, isOpenWorkOrder: true });
        break;
      default:
        props.setError({ isDisplay: true, id: 14, isOpenWorkOrder: true });
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          priceText={priceText}
          formid={formid}
          isDisplayArrows={true}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    totalPrice: state.saleBlock.totalPrice,
    totalPriceOneTime: state.saleBlock.totalPriceOneTime,
    isSubmit: state.saleBlock.isSubmit,
    isValid: state.saleBlock.isValid,
    blockId: state.saleBlock.epiServer.blockId,
    personalInfo: state.saleBlock.personalInfo,
    accountInfo: state.saleBlock.accountInfo,
    offerInfo: state.saleBlock.epiServer.offerInfo,
    supplyType: state.saleBlock.supplyType,
    deliveryCost: state.saleBlock.deliveryCost,
    selectedAddress: state.saleBlock.selectedAddress,
    setupDeliveries: state.saleBlock.setupDeliveries,
    phoneForDelivery: state.saleBlock.phoneForDelivery,
    otpPhone: state.saleBlock.otpPhone,
    otpCode: state.saleBlock.otpCode,
    otpTicketId: state.saleBlock.otpTicketId,
    productsInfo: state.saleBlock.productsInfo,
    premiumPackages: state.saleBlock.premiumPackages,
    isCustomerExposureSuccess: state.saleBlock.isCustomerExposureSuccess,
    chooseNumber: state.saleBlock.chooseNumber,
    isMeshUpgrade: state.saleBlock.isMeshUpgrade,
    technicianArrivalTime: state.saleBlock.technicianArrivalTime,
    technicianArrivalTimeIbc: state.saleBlock.technicianArrivalTimeIbc,
    isCustomerConnectedToIbc: state.saleBlock.isCustomerConnectedToIbc,
    nvIipSeq: state.saleBlock.nvIipSeq,
    isProductUpgraded: state.saleBlock.isProductUpgraded,
    isSkipToNewCustomer: state.saleBlock.isSkipToNewCustomer,
    isFamilyPackage: state.saleBlock.isFamilyPackage,
    //other states
    _phoneForDelivery: state.almostDone.form.phone,
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  reportFbqAnalytics,
  setIsSubmit,
  setIsValid,
  setPhoneForDelivery,
  setError,
  setTransactionId,

  setPhoneListData,
  //loader
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(SummaryPage);
